import {initTopBottom} from "../modulos/topbottom/topbottom";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import {infiniteScrollDetect} from "../modulos/infiniteScrolling/detectAndLoadInfiniteScrolling";

import './css/magazinePage.scss';
import Streaming from "../streaming/streaming";

/**
 *
 * @param {HTMLElement} holder
 */
const loadMagazines = (holder) => {
    fetch(holder.dataset.url)
        .then(response => response.text())
        .then(response => {
            holder.innerHTML = response;
            //Scrolls infinitos
            infiniteScrollDetect();
        })
        .catch(err => {
            holder.innerHTML = '<div style="margin-bottom: 40px;" class="premium-color">No hay revistas disponibles</div><hr>'
        })

}

export const magazinePage = () => {
    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //Módulo de análisis más vistos
    analisisMasVistos();

    const magazines = document.querySelector('div.magazineResults');
    if (magazines) {
        loadMagazines(magazines);
    }


}
